const DEFAULT_PAGE_SIZE = 5;
export default DEFAULT_PAGE_SIZE;
